import { entries } from "remeda";

/**
 * Temporary until https://github.com/remeda/remeda/issues/1122 is resolved.
 */
export function mapValues<T extends Record<string, any>, Value>(
  data: T,
  valueMapper: (value: T[keyof T], key: keyof T, data: T) => Value,
): Record<keyof T, Value> {
  const result = {} as Record<keyof T, Value>;

  for (const [key, value] of entries(data)) {
    const mappedValue = valueMapper(value as T[keyof T], key as keyof T, data);
    result[key as keyof T] = mappedValue;
  }

  return result;
}
